import { DocumentUploadCard } from '../DocumentUploadCard';

const REQUIRED_DOCS = [
  { type: 'registro_publico_comercio', label: 'Registro Público de Comercio' },
  { type: 'acta_constitutiva', label: 'Acta Constitutiva' },
  { type: 'poderes', label: 'Poderes Notariales' },
  { type: 'constancia_csf', label: 'Constancia de Situación Fiscal' },
  { type: 'comprobante_domicilio', label: 'Comprobante de Domicilio' },
  { type: 'declaracion_propietario', label: 'Declaración de Propietario Real' },
  { type: 'opinion_cumplimiento', label: 'Opinión de Cumplimiento SAT' },
  { type: 'caratula_bancaria', label: 'Carátula Bancaria' },
  { type: 'fiel_certificado', label: 'FIEL / Certificado Digital' },
];

interface LegalDocumentsStepProps {
  uploadedDocs: { id: string; documentType: string; originalFilename: string; fileSize: number }[];
  onUpload: (documentType: string, file: File) => void;
  onDelete?: (documentId: string) => void;
  onSubmit: () => void;
  onBack: () => void;
  isSubmitting?: boolean;
  uploadingDocType?: string | null;
}

export const LegalDocumentsStep: React.FC<LegalDocumentsStepProps> = ({
  uploadedDocs,
  onUpload,
  onDelete,
  onSubmit,
  onBack,
  isSubmitting = false,
  uploadingDocType = null,
}) => {
  const getDoc = (type: string) => uploadedDocs.find(d => d.documentType === type);
  const uploadedCount = REQUIRED_DOCS.filter(d => !!getDoc(d.type)).length;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <p className="text-sm text-gray-600">
          Sube todos los documentos legales requeridos para completar este paso.
        </p>
        <span className="text-sm font-medium text-gray-700">
          {uploadedCount} / {REQUIRED_DOCS.length}
        </span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {REQUIRED_DOCS.map(({ type, label }) => (
          <DocumentUploadCard
            key={type}
            label={label}
            documentType={type}
            uploadedFile={getDoc(type)}
            onUpload={onUpload}
            onDelete={onDelete}
            uploadingDocType={uploadingDocType}
          />
        ))}
      </div>

      <div className="flex justify-between pt-2">
        <button
          type="button"
          onClick={onBack}
          className="px-6 py-2 text-sm text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
        >
          Anterior
        </button>
        <button
          onClick={onSubmit}
          disabled={isSubmitting || uploadedCount < REQUIRED_DOCS.length}
          className="px-6 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-60"
        >
          {isSubmitting ? 'Guardando...' : 'Siguiente'}
        </button>
      </div>

      {uploadedCount < REQUIRED_DOCS.length && (
        <p className="text-xs text-amber-600 text-center">
          Faltan {REQUIRED_DOCS.length - uploadedCount} documento(s) por subir.
        </p>
      )}
    </div>
  );
};
